void import(/* webpackChunkName: "logger" */ "@utils/logger").then(
  ({ default: logger }) => {
    logger.setupMonitoring();
  }
);
export {};
